import { observer } from 'mobx-react-lite'

import { SelectField } from 'shared/ui/Select/SelectField/SelectField.tsx'
import { makeTextFieldHighlightLimit, TextField } from 'shared/ui/TextField'
import { IconButton, Label } from 'shared/ui'
import { BRUNCH_NAME_LIMIT } from 'shared/constants/limits.ts'
import {
  type IBranch,
  type IVRStore,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/IVR/store/IVRStore.ts'
import styles from './styles.module.scss'

export const Brunch = observer(
  ({
    brunch,
    store,
    withLabel,
    index,
  }: {
    brunch: IBranch
    store: IVRStore
    withLabel: boolean
    index: number
  }) => {
    const { key, name } = brunch
    const { getBranchKeyOptions, updateBranchData, deleteBranch } = store
    return (
      <div className={styles.wrap}>
        <SelectField
          items={getBranchKeyOptions(brunch)}
          setValue={(value) => updateBranchData({ ...brunch, key: value }, index)}
          value={key}
          labelText={withLabel ? 'Key' : undefined}
          btnProps={{
            fullWidth: true,
            typeBtn: 'stroke',
            size: 'large',
            justifyContent: 'space-between',
          }}
          dropdownProps={{
            width: 90,
            propsDropdownList: {
              minItemWidth: 0,
            },
          }}
        />
        <div>
          {withLabel && (
            <Label
              label={{
                text: 'Name',
              }}
              marginBottom={4}
            />
          )}
          <TextField
            variant={'stroke'}
            size={'medium'}
            InputProps={{
              placeholder: 'Option',
            }}
            value={name}
            onChange={(value) => updateBranchData({ ...brunch, name: value }, index)}
            mainActions={[makeTextFieldHighlightLimit({ limit: BRUNCH_NAME_LIMIT })]}
          />
        </div>
        <IconButton
          onClick={() => deleteBranch(brunch, index)}
          ariaLabel={'Delete'}
          size={'medium'}
          color={'secondary'}
          variant={'icon'}
          icon={'delete'}
          tooltipProps={{
            label: 'Delete',
            placement: 'top',
          }}
          className={styles.delete}
        />
      </div>
    )
  }
)
